<template>
    <td   v-tooltip="'Másolás '+this.actualTable.year+' -> ' +nextYear()">
        <a @click="coppy()"
           class="akg-table-copy btn btn-light">
            <i class=" fa fa-arrow-right "></i>
        </a>
    </td>
</template>

<script>
import swal from "sweetalert2";

export default {
  props: ["actualTable", "rowTables"],
  data() {
    return {
      form: new Form({
        tableId: ""
      })
    };
  },
  methods: {
    nextYear() {
      return this.actualTable.year + 1;
    },
    coppy() {
      var actualTable = this.actualTable;

      var targetTable = _.find(this.rowTables, function(t) {
        return t.year == actualTable.year + 1;
      });

      this.form.tableId = actualTable.id;
      this.form
        .post("ajax/akgTable/copyTable")
        .then(function(data) {
          Object.assign(targetTable, data);
        })
        .catch(e => {
          console.log(e.errors);
        });
      this.$emit("updated", actualTable.year + 1);
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/CoppyKetRowTable.vue